// extracted by mini-css-extract-plugin
module.exports = {"tag":"TagInputTag-tag-2Hnsu Link-link-1rgM9"};